
const PageEnum = {
    SUBSCRIBERS: 'SUBSCRIBERS',
    STEP: 'STEP',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS',
    LOADER: 'LOADER',
    CALLBACK: 'CALLBACK'
  };

  export default PageEnum;
